/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {  Observable } from 'rxjs';
import { ImiauthService } from '../../../controllers/Imiauth';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGGetFormService } from '../../yasag-get.service';


@Injectable()
export class ImiauthHelloFormService extends YASAGGetFormService<__model.IMIAuthorization> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: ImiauthService,
  ) {
    super('ImiauthHello', apiConfigService, ngZone);
    this.init();
  }

  submit(value: typeof this.form.value | false = false, cache = true, only_cache = false): Observable<__model.IMIAuthorization> {
    const result = val => this.service.hello(val);
    return this._submit('__model.IMIAuthorization', result, value, cache, only_cache );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.IMIAuthorization> {
    if (submit) {
      this.submit(value);
    }
    return this._listen('__model.IMIAuthorization', value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    super.reset(value, false); 
  }
  patch(value: typeof this.form.value): void {
    this.form.patchValue(value);
  }
}
